import React from 'react';
import { connect } from 'react-redux';
import { Image, Card, Row, Col } from 'react-bootstrap';
import moment from 'moment';
import task from '../../Media/task.svg';
import { dataBaseManager } from '../hupUtils/utils';
import { popupBot, stateChats } from '../../actions';
import TimerClock from './timer';
//import Draggable from 'react-draggable';

let timeoutLength = 900000;
let timeoutLength2 = 1000;
let timeoutLength4 = 2000;
let timeoutLength3 = 2000;

const styleWidthCard = { borderRadius: '1.8em', background: 'linear-gradient(to bottom, #f8edd200, #f8edd2)' };
const styleHeaderCardOff = { color: '#1a0339', background: 'linear-gradient(90deg, rgb(247, 247, 247) 0%, rgb(143 161 206) 35%, rgb(66 163 175) 100%)', borderRadius: '1.7em 1.7em 0em 0em', height: '6.2vh' };
const styleHeaderCardHight = { color: '#947d0e', background: '#f66fffcc', borderRadius: '1.7em 1.7em 0em 0em', height: '5vh' };
const styleHeaderCardMedium = { color: '#947d0e', background: '#FBC6F6', borderRadius: '1.7em 1.7em 0em 0em', height: '5vh' };
const styleHeaderCardLow = { color: '#947d0e', background: '#f0ff6f3b', borderRadius: '1.7em 1.7em 0em 0em', height: '5vh' };
const styleHeaderCardOn = { color: '#947d0e' };

class listActividades extends React.Component {

    state = { actividades: null, tiempos: 0, horamaxima: 8, primero: null, aux: null, contenido: null, num_end_Task: 0 }

    componentDidMount() {
        this.flag = true;
        if (this.props.userDetail) {
            window.gapi.client.load("https://content.googleapis.com/discovery/v1/apis/calendar/v3/rest")
                .then(() => {
                    const starCountRef2 = this.componentDatabase('get', `Usuario-CalendarGoogle/${this.props.userDetail.idUsuario}`);
                    starCountRef2.on('value', (snapshot) => {
                        this.Calendar = snapshot.val();
                        window.gapi.client.calendar.events.list({ calendarId: this.Calendar.idCalendar.value, }).then((response) => {
                            this.eventCalendar = response;
                        }, (err) => { console.error("Execute error", err); });

                    });
                }, function (err) { console.error("Error loading GAPI client for API", err); });
            this.actividadesTrabajoActividades();
        }

        this.setState({
            primero: <Card border="light" className='taskPrincipal' key={25}>
                <Card.Body >
                    <Card.Title as='h2'>
                        <Row>
                            <Col xs={1} >
                                <Image src={task} className='image_icon_task' alt='Task Hupper'></Image>
                            </Col>
                            <Col md={{ span: 10, offset: 1 }} xs={{ span: 8, offset: 2 }} className='centerTitleTask'>
                                Planifica tu actividad...
                            </Col>
                        </Row>
                    </Card.Title>
                </Card.Body>
            </Card>
        });

        this.consultaTiempo();
    }

    componentDatabase(tipo, path, objectIn, mensaje, mensajeError) {
        let men = dataBaseManager(tipo, path, objectIn, mensaje, mensajeError);
        if (men && men.mensaje)
            this.props.popupBot({ mensaje: men.mensaje });
        return men;
    }
    actividadesTrabajoActividades = () => {

        this.timeout = setTimeout(() => {
            let flagFirst = false;
            const starCountRef = this.componentDatabase('get', `Usuario-Task/${this.props.userDetail.idUsuario}/${moment().format("YYYYMMDD")}`);
            starCountRef.on('value', (snapshot2) => {
                this.setState({ actividades: snapshot2.val() });
                let act = snapshot2.val();

                if (act && act.estado !== undefined) {
                    Object.keys(act).map((key, index) => {

                        let flag = true;
                        if (this.eventCalendar) {
                            Object.keys(this.eventCalendar.result.items).map((key2, index) => {
                                if (this.eventCalendar.result.items[key2].summary === act[key].concepto && this.eventCalendar.result.items[key2].description === key)
                                    flag = false;
                                return this.eventCalendar.result.items[key2];
                            });

                            if (flag && act[key].concepto !== undefined && act[key].synCalendar === undefined && ((this.calendarAcum !== undefined && !this.calendarAcum.includes(key)) || this.calendarAcum === undefined)) {
                                console.log(act[key]);

                                let event = {
                                    'summary': act[key].concepto,
                                    'description': key,
                                    'start': {
                                        'dateTime': moment(act[key]['timeStart'], 'h:mm:ss a'),
                                        'timeZone': 'America/Los_Angeles'
                                    },
                                    'end': {
                                        'dateTime': moment(act[key]['timeEnd'], 'h:mm:ss a'),
                                        'timeZone': 'America/Los_Angeles'
                                    },
                                    'attendees': [],
                                    'reminders': {
                                        'useDefault': false,
                                        'overrides': [
                                            { 'method': 'popup', 'minutes': 10 }
                                        ]
                                    }
                                };
                                if (this.calendarAcum === undefined) {
                                    this.calendarAcum = [];
                                    this.calendarL = [];
                                }
                                this.calendarAcum[key] = act[key].concepto;
                                this.calendarL[key] = event;
                                this.componentDatabase('update', `Usuario-Task/${this.props.userDetail.idUsuario}/${moment().format("YYYYMMDD")}/${key}`, { synCalendar: true });

                                if (flagFirst === false)
                                    this.createEventTrabajo(this.Calendar.idCalendar.value, 0);
                                flagFirst = true;
                            }

                        }
                        return act[key];
                    })
                }
            });
        }, timeoutLength4)
    }


    createEventTrabajo = (calendar, indC) => {

        let event = null;
        Object.keys(this.calendarL).map((key, index) => {
            if (index === indC)
                event = this.calendarL[key];
            return this.calendarL[key];
        });
        if (event !== null) {
            this.timeout = setTimeout(() => {
                window.gapi.client.calendar.events.insert({
                    'calendarId': calendar,
                    'resource': event
                }).then((response) => {
                    console.log("Response", response);
                    this.createEventTrabajo(calendar, indC + 1);
                }, function (err) { console.error("Execute error", err); });
            }, 2000)
        }
    }


    timerTrabajo = () => {
        this.timeout = setTimeout(() => {
            this.setState({ aux: null });
        }, timeoutLength2)
    }


    consultaTiempo = () => {
        this.timeout = setTimeout(() => {
            //  this.renderConsultarTiempoTrabajado();
            this.consultaTiempo();
        }, timeoutLength)
    }

    //validar logica
    /* renderConsultarTiempoTrabajado() {
         //this.renderTiempo();
         if (!this.props.MensajeIvily) return;
         let ant = moment(new Date(this.props.MensajeIvily.horaActivacion ? this.props.MensajeIvily.horaActivacion : this.props.MensajeIvily.inicio));
         let hora = moment().add('minutes', -ant.minutes()).add('hours', -ant.hours());
         if (this.props.MensajeIvily.horaActivacion) {
             hora = moment(this.props.MensajeIvily.tiempoTrabajado, 'HH:mm').add('hours', parseInt(moment(hora).format('HH'))).add('minutes', parseInt(moment(hora).format('mm')));
         }
 
         let tt = parseFloat(hora.format('HH')) + parseFloat(hora.format('mm')) / 60;
         tt = Math.round(tt * 10) / 10;
         if (tt > this.state.tiempos) {
             this.props.statechats('seguimiento');
         }
 
         if (tt > 4 && !this.props.MensajeIvily.estadoTIMS && (new Date().getDay() === 2 || new Date().getDay() === 4)) {
             this.props.statechats('TIM Media');
         }
         if (tt > 4 && !this.props.MensajeIvily.estadoTIMS && (new Date().getDay() === 3 || new Date().getDay() === 5)) {
             this.props.statechats('TIM Semana');
         }
         if (tt > this.state.horamaxima && this.props.estadochat !== "Despedida") { this.props.statechats('Termino dia') }
     }*/


    renderTiempo() {
        const actividadesU = this.state.actividades;
        let x = 0;
        let enProceso = 0;
        let arrayT = [];
        Object.keys(actividadesU).map((key, index) => {
            const objTar = { ...actividadesU[key], key: key }
            arrayT.push(objTar);
            return actividadesU[key];
        });

        arrayT.sort((obj1, obj2) => { return obj1.dificultad.localeCompare(obj2.dificultad); });
        let tiempos = 0;
        Object.keys(arrayT).map((key3, index) => {
            Object.keys(actividadesU).map((key2, index) => {
                if (arrayT[key3].key !== key2) return null;
                if (moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD') > moment(actividadesU[key2].dateStart, 'YYYY-MM-DD')) {
                    if (actividadesU[key2].estado === 'activo')
                        actividadesU[key2].estado = 'anulado';
                    return null;
                }
                if (actividadesU[key2].estado === "activo") {
                    if (x === 0)
                        tiempos = parseInt(actividadesU[key2].tiempoEstimado.substring(0, 2)) + tiempos;
                    x++;
                }
                else if (actividadesU[key2].estado === "trabajando") {
                    if (x === 0)
                        tiempos = parseInt(actividadesU[key2].tiempoEstimado.substring(0, 2)) + tiempos;
                    x++;
                    enProceso++;
                }
                else if (actividadesU[key2].estado === "finalizado") {
                    const ti = moment(new Date(actividadesU[key2].fechaInicio));
                    const tf = moment(new Date(actividadesU[key2].fechaFin));
                    const td = tf.add('hours', -ti.hours('HH')).add('minutes', -tf.minutes);
                    let tt = parseFloat(td.format('HH')) + parseFloat(td.format('mm')) / 60;
                    tt = Math.round(tt * 10) / 10;
                    if (!actividadesU[key2].fechaInicio)
                        tt = 1;
                    tiempos = parseInt(tt + tiempos);
                }
                return null;
            });
            return null;
        });

        if (enProceso === 0)
            this.props.statechats('Seguimiento Inicio');

        this.setState({ tiempos })
    }

    renderActividadXactividad() {

        const actividadesU = this.state.actividades;
        let x = 0;
        let actNum = 0;
        let arrayT = [];

        Object.keys(actividadesU).map((key, index) => {
            const objTar = { ...actividadesU[key], key: key }
            arrayT.push(objTar);
            return actividadesU[key];
        });


        arrayT.sort((obj1, obj2) => {
            if (obj1.prioridad !== undefined)
                return obj1.prioridad.localeCompare(obj2.prioridad);
            return null;
        });

        let tiempoMin = '24:00';
        Object.keys(arrayT).map((key3, index) => {
            Object.keys(actividadesU).map((key2, index) => {
                if (arrayT[key3].key !== key2) return null;
                if (moment().format('YYYY-MM-DD') > moment(actividadesU[key2].dateStart, 'YYYY-MM-DD')) {
                    if (actividadesU[key2].estado === 'activo') {
                        actividadesU[key2].estado = 'anulado';
                    }
                    return null;
                }
                if (moment(tiempoMin, 'HH:mm') > moment(actividadesU[key2].horaPlanificada, 'HH:mm'))
                    tiempoMin = moment(actividadesU[key2].horaPlanificada, 'HH:mm');
                return null;
            });
            return null;
        });

        let f = null;
        let opcionesX = Object.keys(arrayT).map((key3, index) => {

            let opciones2 = Object.keys(actividadesU).map((key2, index) => {
                if (this.props.selectObjective === null || this.props.selectObjective === actividadesU[key2].objetivo) {

                    if (arrayT[key3].key !== key2) return null;
                    if (moment().format('YYYY-MM-DD') > moment(actividadesU[key2].dateStart, 'YYYY-MM-DD')) {
                        if (actividadesU[key2].estado === 'activo') {
                            actividadesU[key2].estado = 'anulado';
                        }
                        return null;

                    }
                    const tiempo = actividadesU[key2]['timeStart'] + '  a  ' + actividadesU[key2]['timeEnd'];

                    if (actividadesU[key2].estado === "activo" || actividadesU[key2].estado === "trabajando") {
                        x++;
                    }
                    actNum++;

                    if (actividadesU[key2].concepto === undefined)
                        return null;
                    if (this.state.aux !== key2) {
                        if (this.state.aux == null && f == null && actividadesU[key2].estado === "activo" && actividadesU[key2].concepto !== undefined) {
                            f = '1';
                            this.setState({ aux: key2 });
                            this.setState({
                                primero:

                                    <Card border="light" className='taskPrincipal' key={'25' + key2}>
                                        <Card.Body >
                                            <Card.Title as='h2' style={styleHeaderCardOn}>
                                                <Row>
                                                    <Col xs={1} >
                                                        <Image src={task} className='image_icon_task' alt='Task Hupper'></Image>
                                                    </Col>
                                                    <Col md={{ span: 10, offset: 1 }} xs={{ span: 8, offset: 2 }} className='centerTitleTaskOn'>
                                                        {actividadesU[key2].concepto}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={{ span: 6, offset: 6 }} xs={{ span: 10, offset: 1 }}  >
                                                        <h6 ><i className="material-icons md-18">access_alarm</i>  {tiempo}</h6>
                                                    </Col>
                                                </Row>
                                            </Card.Title>
                                        </Card.Body>
                                    </Card>

                            });

                        }

                        else {
                            if (x !== 1 && actividadesU[key2].estado === "activo") {
                                let stylePriority = styleHeaderCardLow;
                                if (actividadesU[key2].prioridad >= 0 && actividadesU[key2].prioridad < 2)
                                    stylePriority = styleHeaderCardHight;
                                else if (actividadesU[key2].prioridad >= 2 && actividadesU[key2].prioridad < 5)
                                    stylePriority = styleHeaderCardMedium;
                                return (

                                    <Card style={styleWidthCard} className='taskSecondStop' key={'25' + key2}>
                                        <Card.Header style={stylePriority}>
                                            <Row>
                                                <Col xs={1}>
                                                    <h3>{x}</h3>
                                                </Col>
                                                <Col xs={1} >
                                                    <Image src={task} className='image_icon_task centerTitleTask' alt='Task Hupper'></Image>
                                                </Col>
                                                <Col md={{ span: 7, offset: 3 }} xs={{ span: 9 }} className='sizeTextTask'>
                                                    <i className="material-icons md-18">access_alarm</i> {tiempo}
                                                </Col>
                                            </Row>
                                        </Card.Header>
                                        <Card.Body >

                                            <Row>
                                                <Col xs={{ span: 11, offset: 1 }} className='centerTitleTaskOn'>
                                                    <Card.Text >
                                                        {actividadesU[key2].concepto}
                                                    </Card.Text>
                                                </Col>
                                            </Row>

                                        </Card.Body>
                                    </Card>
                                );
                            }
                        }
                    }
                }
                return null;
            });
            this.setState({ num_end_Task: x })
            return opciones2;

        });

        opcionesX = this.actividadesEmpty(6, actNum, opcionesX)
        return opcionesX;
    }



    actividadesEmpty(limite, actNum, opcionesX) {

        let x = 0;
        for (let index = actNum; index <= limite; index++) {
            x++;
            const element = <Card style={styleWidthCard} className='taskSecondStop' key={'25' + index}>
                <Card.Header style={styleHeaderCardOff}>
                    <Row>
                        <Col xs={1}>
                            <h3>{x}</h3>
                        </Col>
                        <Col xs={1} >
                            <Image src={task} className='image_icon_task centerTitleTask' alt='Task Hupper'></Image>
                        </Col>
                        <Col md={{ span: 7, offset: 2 }} xs={{ span: 8, offset: 1 }} >
                            <i className="material-icons md-18">access_alarm</i>  00:00 a 00:00
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body >

                    <Row>
                        <Col xs={{ span: 11, offset: 1 }} className='centerTitleTask'>

                            <Card.Text >
                                Programa tu nueva actividad
                            </Card.Text>

                        </Col>
                    </Row>

                </Card.Body>
            </Card>
            opcionesX.push(element);
        }
        return opcionesX;
    }

    renderActividades() {


        if (this.flag === true) {
            this.timeout = setTimeout(() => {
                timeoutLength3 = 2000;
                this.flag = true;
                this.timerTrabajo();
                this.setState({ contenido: this.renderActividadXactividad() });
            }, timeoutLength3);
        }
        this.flag = false;
    }


    render() {

        let contenido = null;
        if (this.state.actividades) {
            this.renderActividades();
        }
        else
            contenido = this.actividadesEmpty(5, 0, [])


        let tiempo = null;
        // if (!this.props.isChat)
        tiempo = <TimerClock programa={false}></TimerClock>;

        return (
            <Row>
                <Col  >
                    <Row>
                        <Col md={{ span: 8, offset: 4 }} xs={{ span: 12 }}>
                            {tiempo}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={{ span: 11, offset: 1 }} xs={12}>
                            {this.state.primero}
                        </Col>
                    </Row>
                    <Row className='tasks_second_level'>
                        <Col className='centerTitleTask' md={{ span: 11, offset: 1 }} xs={{ span: 12 }}  >
                            <h5>{this.props.titulo + ' ' + this.state.num_end_Task}</h5>
                        </Col>
                    </Row>
                    <Row className='offsetTask'>
                        <Col md={{ span: 10, offset: 2 }} xs={{ span: 11, offset: 1 }}   >
                            {contenido ? contenido : this.state.contenido}
                        </Col>
                    </Row>
                </Col>
            </Row>

        );
    }
};

const mapAppStateToProps = (state) => (
    {
        userDetail: state.mainReducer.userDetail,
        isChat: state.mainReducer.isChat,
        selectObjective: state.mainReducer.selectObjective,
        //   MensajeIvily: state.chatReducer.MensajeIvily,
    });


export default connect(mapAppStateToProps, { stateChats, popupBot })(listActividades);